import { formatDate } from '@app/utils/dateUtils';
import { TableCell } from '@mui/material';

import { RegularText } from '@app/components/common/RegularText';
import { ColumnInterface, GenericObject } from '@app/components/common/Table/DefaultTable/types';

interface DateCellProps {
  column: ColumnInterface;
  row: GenericObject;
}

export const DateCell = ({ column, row }: DateCellProps) => {
  return (
    <TableCell align="left" sx={{ maxWidth: 300 }}>
      <RegularText sx={{ maxHeight: 65, overflow: 'auto' }}>{formatDate(row[column.key] as string)}</RegularText>
    </TableCell>
  );
};
